module.exports = __webpack_public_path__ + "static/media/Studios_BKN_Cafe_Lobby-dark.f3dab67c.jpg";